import React from 'react'
import { findDOMNode } from 'react-dom'
import PopoverComponent, {PopoverComponentProps, PopoverComponentState} from "../../base-component/popover-component"

import Popover from '../../gd-popover/popover-v2'
import PopoverPosition from '../../gd-popover/popover-position'

import Classes from 'classnames'

type Props = PopoverComponentProps & {
    optionComponent : func
    options?        : any[]
    addLabel?       : string

    onUserSelect?   : callback
    onClickAdd?     : callback

    disabled?       : boolean
    className?      : string
}

type State = PopoverComponentState

class SelectorMoreComponent extends PopoverComponent<Props, State> {

    static defaultProps: Partial<Props> = {
        options: []
    }

    constructor(props:Props) {
        super(props)

        this._bind('onOptionClick', 'onClickAdd')
    }

    onOptionClick(id:any) {
        const { disabled, onUserSelect } = this.props
        if ( disabled ) return

        if (!id) id = 'all'
        this.hidePopover(null,()=>{
            if (onUserSelect) onUserSelect(id)
        })
    }

    onClickAdd() {
        this.hidePopover(null,()=>{
            const { onClickAdd } = this.props
            if (onClickAdd) onClickAdd()
        })
    }

    renderPopover() {
        const { options, optionComponent: OptionComponent, addLabel, onClickAdd } = this.props
        const { showPopover } = this.state

        if (showPopover) {
            const popoverPosition = new PopoverPosition({
                attachment      : "top center",
                targetAttachment: "bottom center",
            })

            return (
                <Popover popoverClass="gd-selector2-more-component-popover"
                         className="gd-selector2-more-component-popover-container"
                         position={popoverPosition}
                         onClickOutside={()=>{this.hidePopover()}}
                         getTargetFunc={()=>findDOMNode(this)}>

                    {options.map((o:any)=><OptionComponent key={o.value}
                                                     value={o.value}
                                                     icon={o.icon}
                                                     iconObj={o.iconObj}
                                                     label={o.label}
                                                     parent={this}/>)}

                    <div className="cf"> </div>

                    {onClickAdd &&
                    <div className="add-label" onClick={this.onClickAdd}>
                        <div className="add-label-icon i5-plus"> </div>{addLabel}
                    </div>}

                </Popover>
            )
        }
    }

    render() {
        const componentClasses = Classes('gd-selector2-more-component', this.props.className)

        return (
            <div className={componentClasses}
                 onClick={this.showPopover}>
                <div className="gd-selector2-more-component-icon i5-more"> </div>
                {this.renderPopover()}
            </div>
        )
    }
}

export default SelectorMoreComponent
